<div class="db-webp-via-server-dialog">
  <h1 [innerHTML]="'text_howToServeWebPViaServer' | dbText"></h1>
  <p class="mt5 mb30" [innerHTML]="(apacheServer ? 'text_howToServeWebPViaServerApacheDesc' : 'text_howToServeWebPViaServerDesc') | dbText"></p>

  <div class="db-webp-via-server-dialog__code" *ngIf="!apacheServer">
    <div class="mb8">
      <p [innerHTML]="'text_beforeServerDirective' | dbText"></p>
      <a class="ds-btn ds-btn-small" ngxClipboard [cbContent]="codeBeforeServerDirective" (cbOnSuccess)="isCopiedBeforeServerCode = true"
       [ngClass]="{'ds-btn-disabled': isCopiedBeforeServerCode }">
        <span>{{(isCopiedBeforeServerCode ? 'text_copied' : 'text_copy') | dbText}}</span>
      </a>
    </div>
    <div class="mt13 db-webp-via-server-dialog__textarea">
      <pre [innerHTML]="codeBeforeServerDirective"></pre>
    </div>
  </div>

  <div class="db-webp-via-server-dialog__code mt30" *ngIf="!apacheServer">
    <div class="mb8">
      <p [innerHTML]="'text_insideServerDirective' | dbText"></p>
      <a class="ds-btn ds-btn-small" ngxClipboard [cbContent]="codeInsideServerDirective" (cbOnSuccess)="isCopiedInsideServerCode = true"
         [ngClass]="{'ds-btn-disabled': isCopiedInsideServerCode }">
        <span>{{(isCopiedInsideServerCode ? 'text_copied' : 'text_copy') | dbText}}</span>
      </a>
    </div>
    <div class="mt13 db-webp-via-server-dialog__textarea">
      <pre [innerHTML]="codeInsideServerDirective"></pre>
    </div>
  </div>

  <div class="db-webp-via-server-dialog__code mt30" *ngIf="apacheServer">
    <div class="mb8">
      <p [innerHTML]="'text_insideServerDirective' | dbText"></p>
      <a class="ds-btn ds-btn-small" ngxClipboard [cbContent]="codeApacheServerDirective" (cbOnSuccess)="isCopiedApacheServerCode = true"
         [ngClass]="{'ds-btn-disabled': isCopiedApacheServerCode }">
        <span>{{(isCopiedApacheServerCode ? 'text_copied' : 'text_copy') | dbText}}</span>
      </a>
    </div>
    <div class="mt13 db-webp-via-server-dialog__textarea">
      <pre [innerHTML]="codeApacheServerDirective"></pre>
    </div>
  </div>
</div>
